export default __webpack_public_path__ + "locales/az/Profile.json?hash=79c31ef2b5c2a65ad4d8b13f61ad31a6";